import { createQuiz } from "@/components/quizEngine";

const traits = ["curious", "clever", "kind", "loyal", "elegant", "cheerful", "proud", "mysterious", "bold"];

const bank = [
  ["Someone hands you a strange mushroom. You…", [
    ["Taste it, purely for science", { curious: 3 }],
    ["Politely decline", { elegant: 1, kind: 1 }],
    ["Ask where they found it", { clever: 2 }],
    ["Make sure no one else eats it", { loyal: 2 }],
    ["Gossip about who might be poisoning whom", { cheerful: 2 }],
  ]],
  ["Your favorite place in the palace:", [
    ["The herb garden", { curious: 2, kind: 1 }],
    ["A quiet pavilion by the pond", { elegant: 2 }],
    ["The kitchens, for snacks and rumors", { cheerful: 2 }],
    ["The training grounds", { bold: 2, loyal: 1 }],
    ["The records room", { clever: 2, mysterious: 1 }],
  ]],
  ["A mysterious illness spreads. You…", [
    ["Investigate the cause immediately", { curious: 2, clever: 1 }],
    ["Care for the sick", { kind: 2 }],
    ["Protect the people you serve", { loyal: 2 }],
    ["Calmly take command", { proud: 1, bold: 1, elegant: 1 }],
    ["Notice who benefits from it", { mysterious: 2, clever: 1 }],
  ]],
  ["Pick a gift:", [
    ["A rare medicinal herb", { curious: 2 }],
    ["A beautiful hairpin", { elegant: 2 }],
    ["Sweet mooncakes", { cheerful: 2 }],
    ["A sharp dagger", { bold: 2 }],
    ["A letter in secret code", { mysterious: 2 }],
  ]],
  ["How do you react to flattery?", [
    ["Suspicious. What do they want?", { clever: 1, mysterious: 1 }],
    ["Gracefully accept it", { elegant: 2 }],
    ["Blush and get flustered", { kind: 1, cheerful: 1 }],
    ["Expect it. I deserve it", { proud: 2 }],
    ["Ignore it and get back to work", { loyal: 1, curious: 1 }],
  ]],
  ["Your work style:", [
    ["Experiment until I find the answer", { curious: 2, bold: 1 }],
    ["Plan every move in advance", { clever: 2 }],
    ["Quietly support everyone else", { loyal: 2, kind: 1 }],
    ["Delegate with charm", { elegant: 1, proud: 1 }],
    ["Chat the whole time", { cheerful: 2 }],
  ]],
  ["You overhear a secret. You…", [
    ["Keep it forever", { loyal: 2, mysterious: 1 }],
    ["Use it to solve a mystery", { clever: 2 }],
    ["Tell your best friend (just one)", { cheerful: 2 }],
    ["Pretend you heard nothing", { elegant: 1, mysterious: 1 }],
    ["Confront the person directly", { bold: 2 }],
  ]],
  ["Pick a color:", [
    ["Herbal green", { curious: 2 }],
    ["Imperial purple", { elegant: 1, proud: 1 }],
    ["Jade", { kind: 1, cheerful: 1 }],
    ["Midnight blue", { loyal: 1, mysterious: 1 }],
    ["Crimson", { bold: 1, proud: 1 }],
  ]],
  ["What would you study?", [
    ["Poisons and their cures", { curious: 3 }],
    ["Strategy and board games", { clever: 2, bold: 1 }],
    ["Music and poetry", { elegant: 2 }],
    ["Martial arts", { bold: 2 }],
    ["Healing for those in need", { kind: 2 }],
  ]],
  ["Your biggest weakness:", [
    ["I can't resist a mystery", { curious: 2 }],
    ["I'm too proud to ask for help", { proud: 2 }],
    ["I trust too easily", { kind: 2 }],
    ["I talk way too much", { cheerful: 2 }],
    ["I keep everything to myself", { mysterious: 2 }],
  ]],
  ["A royal banquet is tonight. You…", [
    ["Check every dish for poison", { curious: 2, loyal: 1 }],
    ["Dress to dazzle", { elegant: 2 }],
    ["Stay close to the person you protect", { loyal: 2 }],
    ["Watch the guests' every move", { mysterious: 1, clever: 1 }],
    ["Enjoy the food, obviously", { cheerful: 2 }],
  ]],
  ["Pick a pet:", [
    ["A frog for experiments", { curious: 2 }],
    ["An elegant white cat", { elegant: 2 }],
    ["A loyal hound", { loyal: 2 }],
    ["A chatty songbird", { cheerful: 2 }],
    ["A clever crow", { clever: 1, mysterious: 1 }],
  ]],
  ["How do you show you care?", [
    ["Make medicine for them", { kind: 1, curious: 1 }],
    ["Protect them without a word", { loyal: 2 }],
    ["Shower them with gifts", { proud: 1, elegant: 1 }],
    ["Make them laugh", { cheerful: 2 }],
    ["Solve their problems before they notice", { clever: 2 }],
  ]],
  ["Someone insults you. You…", [
    ["Shrug. I have work to do", { curious: 1, mysterious: 1 }],
    ["Reply with a perfectly calm smile", { elegant: 2 }],
    ["Outwit them later", { clever: 2 }],
    ["Stand up for yourself", { bold: 2 }],
    ["Feel hurt, then forgive", { kind: 2 }],
  ]],
  ["Your ideal day off:", [
    ["Foraging for herbs", { curious: 2 }],
    ["Tea and calligraphy", { elegant: 2 }],
    ["Visiting family", { kind: 1, loyal: 1 }],
    ["Gossiping with friends", { cheerful: 2 }],
    ["A long game of strategy", { clever: 2 }],
  ]],
  ["Pick a motto:", [
    ["Curiosity is the best medicine", { curious: 3 }],
    ["Grace in every step", { elegant: 2 }],
    ["Duty before everything", { loyal: 2, proud: 1 }],
    ["Kindness costs nothing", { kind: 2 }],
    ["Every move is part of the plan", { clever: 2, mysterious: 1 }],
  ]],
  ["People first notice your…", [
    ["Sharp eyes", { clever: 1, curious: 1 }],
    ["Stunning beauty", { elegant: 2 }],
    ["Warm smile", { kind: 1, cheerful: 1 }],
    ["Steady presence", { loyal: 2 }],
    ["Fearless attitude", { bold: 2 }],
  ]],
  ["Choose a scent:", [
    ["Bitter herbs", { curious: 2 }],
    ["Plum blossom", { elegant: 1, kind: 1 }],
    ["Incense", { mysterious: 2 }],
    ["Fresh tea", { loyal: 1, kind: 1 }],
    ["Sweet osmanthus", { cheerful: 2 }],
  ]],
  ["In a crisis, you are…", [
    ["The one finding the cause", { curious: 1, clever: 1 }],
    ["The one keeping everyone calm", { elegant: 1, kind: 1 }],
    ["The one guarding the door", { loyal: 1, bold: 1 }],
    ["The one giving orders", { proud: 2 }],
    ["The one cheering everyone up", { cheerful: 2 }],
  ]],
  ["Pick a treasure:", [
    ["An old medical book", { curious: 2, clever: 1 }],
    ["A jade pendant", { elegant: 1, kind: 1 }],
    ["A family heirloom sword", { bold: 1, loyal: 1 }],
    ["A secret letter", { mysterious: 2 }],
    ["A box of sweets", { cheerful: 2 }],
  ]],
  ["Your dream job in the palace:", [
    ["Royal apothecary", { curious: 2, kind: 1 }],
    ["Imperial advisor", { clever: 2, proud: 1 }],
    ["Royal guard", { bold: 1, loyal: 2 }],
    ["Beloved consort", { elegant: 2 }],
    ["Head of the palace gossip network", { cheerful: 2, mysterious: 1 }],
  ]],
];

const characters = [
  { name: "Maomao", title: "Apothecary of the Rear Palace", text: "Endlessly curious and a little bit poison-obsessed. No mystery escapes your sharp eyes.", traits: { curious: 3, clever: 2, bold: 1 }, colors: ["#2d6a4f", "#b8f2a8", "#f2f0ea"], image: "/img/ad/maomao.jpg" },
  { name: "Jinshi", title: "Overseer of the Rear Palace", text: "Breathtakingly charming, with far more depth than your pretty smile suggests.", traits: { elegant: 3, mysterious: 2, bold: 1 }, colors: ["#7b2cbf", "#e9b949", "#fff8e7"], image: "/img/ad/jinshi.jpg" },
  { name: "Gaoshun", title: "Jinshi's loyal attendant", text: "Calm, capable and endlessly patient. Everyone relies on you, and you never let them down.", traits: { loyal: 3, kind: 1, clever: 1 }, colors: ["#2b2d6e", "#6b5b5b", "#f2f0ea"] },
  { name: "Gyokuyou", title: "Consort of the Jade Pavilion", text: "Warm, bright and quietly brave. You treat everyone around you like family.", traits: { cheerful: 2, kind: 2, bold: 1 }, colors: ["#c1121f", "#8fe3cf", "#e9b949"] },
  { name: "Lihua", title: "Consort of the Crystal Pavilion", text: "Proud and graceful, with a strength that grows through every hardship.", traits: { proud: 2, elegant: 2, kind: 1 }, colors: ["#2b2d6e", "#a0d2ff", "#f2f0ea"] },
  { name: "Lishu", title: "The young high consort", text: "Shy and gentle, with a soft heart that deserves the whole world's protection.", traits: { kind: 3, elegant: 1 }, colors: ["#ffd6e0", "#f7b2c8", "#fff8e7"] },
  { name: "Ah-Duo", title: "The unconventional consort", text: "Elegant, bold and effortlessly cool. You walk your own path with grace.", traits: { elegant: 2, bold: 2, mysterious: 1 }, colors: ["#6a2c70", "#f2f0ea", "#1b1b1f"], image: "/img/ad/ah-duo.jpg" },
  { name: "Xiaolan", title: "Palace maid and best friend", text: "Chatty, sunny and always up on the latest gossip. You make every day brighter.", traits: { cheerful: 3, curious: 1, kind: 1 }, colors: ["#ffd166", "#f7b2c8", "#b8f2a8"] },
  { name: "Luomen", title: "Maomao's gentle father, a physician", text: "Wise, humble and endlessly kind. You heal people in more ways than one.", traits: { kind: 2, clever: 2, loyal: 1 }, colors: ["#6b5b5b", "#f2f0ea", "#8fe3cf"], image: "/img/ad/luomen.jpg" },
  { name: "Lakan", title: "The eccentric strategist", text: "A brilliant mind with peculiar habits. You always see ten moves ahead.", traits: { clever: 3, bold: 2, proud: 1 }, colors: ["#1b1b1f", "#e9b949", "#6b5b5b"], image: "/img/ad/lakan.jpg" },
  { name: "Lahan", title: "Lakan's clever adopted son", text: "A numbers genius who sees the world in perfect calculations. Charming, practical and always one step ahead.", traits: { clever: 3, curious: 1, cheerful: 1 }, colors: ["#2b2d6e", "#c1121f", "#f2f0ea"], image: "/img/ad/lahan.jpg" },
  { name: "Suiren", title: "Jinshi's steadfast lady-in-waiting", text: "Composed and quietly formidable. Nothing in the household happens without you knowing.", traits: { loyal: 2, elegant: 1, mysterious: 1, clever: 1 }, colors: ["#9fa8ff", "#f2f0ea", "#6b5b5b"] },
  { name: "Basen", title: "Gaoshun's earnest son", text: "Strong, sincere and a little hot-headed. Your loyalty is as solid as your sword arm.", traits: { bold: 3, loyal: 2 }, colors: ["#3a86ff", "#2b2d6e", "#f2f0ea"] },
  { name: "Meimei", title: "Courtesan of the Verdigris House", text: "Poised, worldly and wise. You protect the people you love with quiet grace.", traits: { elegant: 2, clever: 1, mysterious: 1, kind: 1 }, colors: ["#c1121f", "#f7b2c8", "#e9b949"], image: "/img/ad/meimei.jpg" },
  { name: "Yinghua", title: "Lady-in-waiting of the Jade Pavilion", text: "Cheerful, devoted and fiercely protective of your lady and your friends.", traits: { loyal: 2, cheerful: 1, kind: 1 }, colors: ["#8fe3cf", "#fff8e7", "#f7b2c8"] },
  { name: "Loulan", title: "Consort of the Garnet Pavilion", text: "A master of disguise with a new look every day. Bold, playful and hiding far more than anyone guesses.", traits: { mysterious: 3, bold: 2, cheerful: 1 }, colors: ["#ff6f61", "#e9b949", "#2a9d8f"] },
];

export const AD = createQuiz({ traits, bank, characters });

export const AD_PAIRS = [
  ["Maomao", "Jinshi"], ["Jinshi", "Gaoshun"], ["Maomao", "Xiaolan"],
  ["Maomao", "Luomen"], ["Gyokuyou", "Yinghua"], ["Gaoshun", "Basen"],
];
